import { createSelector } from 'reselect'
import { sum } from 'lib/array/arrayUtils'
import getLuxPlusRedeemedBenefits from 'luxPlus/selectors/benefits/getLuxPlusRedeemedBenefits'

/**
 * Total value saved within the member's current subscription period ("this year alone"), as opposed
 * to {@link getLuxPlusTotalValueSaved} which spans the whole membership since joining.
 *
 * Scoped to benefits redeemed on or after the current period's start date. Unit-based benefits
 * contribute no dollar value (mirrors getLuxPlusTotalValueSaved).
 */
const getLuxPlusValueSavedThisYear = createSelector(
  (state: App.State) => getLuxPlusRedeemedBenefits(state),
  (state: App.State) => state.auth.account.luxPlus.member.subscription.item?.currentPeriodStartDate,
  (redeemedBenefits, currentPeriodStartDate): number => {
    if (!redeemedBenefits.length || !currentPeriodStartDate) return 0

    const periodStartMs = new Date(currentPeriodStartDate).getTime()

    const itemsThisYear = redeemedBenefits
      .filter(item => new Date(item.updatedAt).getTime() >= periodStartMs)
      .map(item => (item.unit === 'units' ? { ...item, adjustment: 0 } : item))

    return sum(itemsThisYear, item => item.adjustment)
  },
)

export default getLuxPlusValueSavedThisYear
